<template>
  <!-- <router-link
    :to="{ path: '/' + Id +'/' + ApiKey + '/' + Os + '/' + Country + '/?'+ ADV_ID +'&cval='+Cval + LANG + OPTIONAL_PARAMS }"
  > -->
    <div class="smallcard-wrapper"
      :class="{'open': open}"
      :style="styleObject">
      <div v-if="open" class="close-btn" @click="handleView()"><img src="@/assets/close-btn.svg"/></div> 
      <img v-if="Advertorial && open" class="advcover animated fadeInDown" :src="Advertorial" alt />
      <div class="grid-container" @click="!open ? handleView() : null">
        <img class="mImg maxImgSize" :src="IconURL" alt="Card Image" />
        <div class="mText">
          <p class="mTitle" v-html="Title"></p>
          <p>
            <span class="c-Fast" v-if="Model == 'CPA'" v-html="$locale.cards.followsteps">Install and follow the steps</span>
            <span class="c-Fast" v-html="$locale.cards.installNopen" v-else>Install and open the app</span>
          </p>
          <p v-if="!open || $route.query.style !== 'myAppTree'">
            <!-- <img class="clockImg" src="../assets/clock.png" alt /> -->
            <span style="font-size: 0.8rem!important">{{Time}}</span>
            <!-- {{Time}} -->
          </p>
          <p v-else v-html="$locale.cards.itwillplant+': '+Coins+' '+$locale.cards.trees">
          </p>
        </div>
        <button v-if="!open" class="mButton">
          <div v-if="this.$cookie.get(Id) == null">
            <span v-if="$route.query.style == 'myAppTree'" class="tree-coefficient">{{Coins/Ratio}}</span>
            <span v-else>{{Coins}}</span>
            <img class="coin-logo img-responsive"/>
          </div>
          <div v-else>
            <img class="coin-logo img-responsive done" src="../assets/done.svg" />
          </div>
        </button>
      </div>
      <div v-if="Description" v-html="Description" class="description"
      :class="{'description-clamp': !open}"></div>
        <div class="m-3 text-left text-secondary" v-html="$locale.cards.onlyonce"></div>
        <div class="actions-container">
          <div v-for="(action,index) in actions = divideActions(FastActions)" :key="action.ID">
            <Actions v-if="index < actions.length - 1" :index="index+1" :action="action"></Actions>
            <LastAction v-else :index="index+1" :action="action"></LastAction>
          </div>
        </div>
      <!-- </div> -->
      <div>
        <button
          class="submitB"
          v-on:click="emit('open-store')"
          v-html="(!this.$cookie.get(Id)) ? $locale.cards.download : $locale.cards.ongoing"
        >Download</button>
      </div>
    </div>
  <!-- </router-link> -->
</template>

<script>
import Actions from "./Actions.vue";
import LastAction from "./LastAction.vue";

export default {
  name: "Card",
  data() {
    return {
      ADV_ID: "",
      LANG: "",
      OPTIONAL_PARAMS: "",
      open: false,
      styleObject:{
        transform: 'translate(0px,0px)',
        maxHeight: '6.1rem',
        overflowY: 'hidden',
        position: ''
      }
    };
  },
  props: [
    "Title",
    "FastActions",
    "Time",
    "Coins",
    "IconURL",
    "Id",
    "ApiKey",
    "Os",
    "Country",
    "Adv_id",
    "Cval",
    "Model",
    "Lang",
    "OptionalParams",
    "Ratio",
    "Metadata",
    "Description",
    "Advertorial"
  ],

  activated(){
    /* eslint-disable no-console*/
    if(this.open)
      this.handleView()
  },

  created() {
    if (this.Adv_id != undefined)
      this.ADV_ID = "?&advertising_id=" + this.Adv_id;
    if (this.Lang != "") this.LANG = "&lang=" + this.Lang;
    if (this.OptionalParams.length > 0) {
      var qElements = "";
      this.OptionalParams.forEach(el => {
        if (
          !el.includes("lang") &&
          !el.includes("cval") &&
          !el.includes("name") &&
          !el.includes("advertising_id") &&
          !el.includes("totalCoins")
        ) {
          qElements += "&" + el;
        }
      });
      this.OPTIONAL_PARAMS = qElements;
    }
    if(this.Description)
        // this.styleObject.maxHeight = '135px';
        this.styleObject.maxHeight = '7.86rem';

  },
  methods:{
    emit: function(eventname){
      this.$cookie.set(this.Id, "1");
      this.$emit(eventname, this.Adv_id)
    },
    getSubtitle: function(element) {
      var subtitle = "";

      if (element.length != 0) {
        if (this.$route.query.lang) {
          element.forEach(el => {
            if (el.Language == this.$route.query.lang) subtitle = el.Subtitle;
          });
        } else subtitle = element[0].Subtitle;
      }

      return subtitle;
    },
    divideActions: function(actions) {
      if (actions.length > 0) return actions.split("|");
      else return null;
    },
    handleView: function(){
      this.open = !this.open;
      //let viewportOffset = el.target.getBoundingClientRect(); //this take clicked element's bounding client rect that in this case leads to positioning problems
      let viewportOffset = this.$el.getBoundingClientRect();  //so we use the whole component element

      if(this.open){
        document.body.style.top = '-' + window.scrollY + 'px';
        // document.body.style.position = 'fixed';
        document.body.style.overflowY = 'hidden';

        this.styleObject.transform = 'translate('+ viewportOffset.left * -1 +'px, '+ viewportOffset.top * -1 +'px)';
        this.styleObject.maxHeight = document.documentElement.clientHeight+'px';
        this.styleObject.overflowY = 'scroll';
        // this.styleObject.position = 'fixed';
      }else{
        this.styleObject.transform = 'translate(0px, 0px)';
        this.styleObject.maxHeight = this.Description ? '7.86rem' : '6.1rem';
        this.styleObject.overflowY = 'hidden';
        this.styleObject.position = '';

        let scrollY = document.body.style.top;
        document.body.style.top = '';
        document.body.style.position = '';
        document.body.style.overflowY = 'scroll';
        window.scrollTo(0, parseInt(scrollY) * -1);
      }
    },
  },
  components:{
    // DetailsBox,
    Actions,
    LastAction
  }
};
</script>
<style scoped lang="scss">
  .grid-container{
    position: relative;
    max-height: 50%;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    /* background-color: white; */
    /* border-radius: 25px; */
  }

  .smallcard-wrapper{
    position: relative;
    /* max-height: 50%; */
    /* display: grid; */
    /* grid-template-columns: 3fr 1fr; */
    /* grid-template-rows: 2fr 1fr; */
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: white;
    border-radius: 25px;
    // -webkit-box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // -ms-box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // -o-box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // box-shadow: 5px 5px 10px rgba(190,190,190, 0.16), 5px 5px 10px rgba(190,190,190, 0.23);
    // margin: 3%;
    margin-left: 3%;
    margin-right: 3%;
    margin-bottom: 3%;
    // overflow: hidden;
    transition: all .5s cubic-bezier(.6,0,.45,1.2);
    // transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);

     &.open{
      z-index: 100;
      border-radius: 0;
      border: 0;
      width: 100vw;
      height: 100vh;
      // transition: max-height 5s ease-in-out;
      transition: all .5s cubic-bezier(.6,0,.45,1.2);
    }

    .advcover, .mText, .description, .actions-container{
      pointer-events: none;
    } 

    .submitB{
      border: none;
      position: relative!important;
      width: 95%!important;
      border-radius: 25px!important;
      padding: 4%!important;
      margin-bottom: 0.6rem;
    }

    .actions-container{
      margin-top: 2rem;
      margin-bottom: 2rem;
    }

    .description{
      text-align: left;
      margin-left: 1rem;
      margin-right: 1rem;
    }

    .description-clamp{
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 80%;
      overflow: hidden;
    }

    .maxImgSize{
      max-height: 6.1rem;
      height: min-content; //it stretches the icon when screen is too thin, but it's needed for wide icons that don't align themselves in center (vertically)
    }

    // .advcover{

    // }
  }

</style>